<h2 class="center-page-heading">{{ "settings_api_page_heading" | translate }}</h2>
<p class="center-page-description">{{ "settings_api_page_description" | translate }}</p>

<p-card class="mx-[-2rem] mt-6 mb-2 p-4">
    <div class="">
        <div class="gap-4">
            <div class="col-span-6">
                <h3 class="tb-h5">{{ "api_buttonnewkey" | translate }}</h3>

                <p-message
                    *ngIf="!(userService.currentUser$ | async)?.hasPermissionStr('MANAGE_SUBSCRIPTION')"
                    severity="warn"
                    text="{{ 'api_keypermission' | translate }}"
                    styleClass="mb-8 mt-6"
                ></p-message>

                <div *ngIf="!!(userService.currentUser$ | async)?.hasPermissionStr('MANAGE_SUBSCRIPTION')">
                    <p>{{ "api_keyinfo" | translate }}</p>

                    <i *ngIf="isLoading" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                    <div *ngIf="!isLoading" style="display: grid grid-cols-12 gap-4">
                        <div class="mt-6 flex justify-between">
                            <div
                                class="field-checkbox assign-wrapper"
                                pTooltip="{{ 'api_button_proFeature' | translate }}"
                                [tooltipDisabled]="isPro"
                                tooltipPosition="top"
                            >
                                <p-button
                                    data-testid="settings-api-key-create"
                                    *ngIf="!hasApiKey"
                                    icon="pi pi-key"
                                    label="{{ 'api_buttonnewkey' | translate }}"
                                    (onClick)="newAPIKey()"
                                    [disabled]="!isPro"
                                ></p-button>
                                <p-button
                                    data-testid="settings-api-key-copy"
                                    *ngIf="hasApiKey"
                                    icon="pi pi-copy"
                                    label="{{ 'api_button_copy' | translate }}"
                                    (onClick)="copyAPIKey()"
                                    [disabled]="!isPro"
                                ></p-button>
                                @if (hasApiKey) {
                                    <button
                                        data-testid="settings-api-key-delete"
                                        type="button"
                                        pButton
                                        severity="danger"
                                        class="p-button-text ml-2"
                                        (click)="deleteAPIKey()"
                                    >
                                        <i class="pi pi-trash"></i> {{ "api_button_delete" | translate }}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-card>

<div class="mt-8">
    {{ "settings_api_learn_more" | translate }}
    <a class="cursor-pointer" (click)="openDoc()">{{ "settings_api_learn_more_link_text" | translate }}</a>
</div>
